import { Table, ConfigProvider, Tooltip, Row, Button } from "antd";
import React, { useEffect, useState } from "react";

import TreatmentPlanTablePatientEducatoin from "./TreatmentPlanTablePatientEducatoin";

import { controller } from "../controller";
import "./style.css";

const TreatmentPlanTable = (props) => {
  const [data, setData] = useState([]);
  const [edulist, setEduList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasDiscount, setHasDiscount] = useState(false);
  const [openPopoverKey, setOpenPopoverKey] = useState(null); // Track which Popover is open
  const [isLoadingEducationalContent, setIsLoadingEducationalContent] = useState([]);

  const handleEduList = async (key) => {
    var url = window.location.href;
    var urlParams = new URLSearchParams(url.slice(url.indexOf("?")));
    var patientId = urlParams.get("patient_id");
    try {
      setIsLoadingEducationalContent((prevIDs) => [...prevIDs, key]);
      var response = await controller.getTreatmentPlanDetail(patientId);

      if (response.status < 250) {
        const data = await response.json;
        setEduList(data); // Set state with fetched data
        data.educational_content[0].video_file.forEach((video) => {
          // if (video.link) window.open(video.link, "_blank", "noopener,noreferrer");
        });
      } else {
        console.log("Response status not OK:", response.status);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
      //message.error("Something went wrong while getting treatments data");
    } finally {
      setIsLoadingEducationalContent((prevIDs) => prevIDs.filter((id) => id !== key));
    }
  };

  // useEffect(() => {
  //   handleEduList();
  // }, []);

  useEffect(() => {
    setCurrentPage(0); // Reset currentPage when edulist changes
  }, [edulist]);

  useEffect(() => {
    // Check if the currently open Popover needs to redirect
    if (openPopoverKey !== null && edulist && edulist.educational_content && edulist.educational_content.length > 0) {
      var currentContent = edulist.educational_content[0].video_file[currentPage];
      if (currentContent && currentContent.redirect === true && currentContent.link) {
        // window.open(currentContent.link, "_blank", "noopener,noreferrer");
        setOpenPopoverKey(null); // Close the Popover after redirect
      }
    }
  }, [currentPage, edulist]);

  useEffect(() => {
    if (props.data) {
      // Flatten the data to include each treatment plan as a separate row, with children for procedures
      var flattenedData = props.data
        .flatMap(function (item) {
          return item.treatment_plans.map(function (tp) {
            // Filter educational content to only include items with valid video files
            var filteredEducationalContent = (tp.educational_content || []).filter(function (content) {
              return content.video_file && content.video_file.length > 0;
            });

            // Map educational content to include only valid videos
            var educationalContent = filteredEducationalContent
              .map(function (content) {
                return {
                  description: content.description,
                  videos: (content.video_file || [])
                    .filter(function (video) {
                      return video.link || video.video;
                    })
                    .map(function (video) {
                      return {
                        link: video.link || null,
                        video: video.video || null,
                        redirect: video.redirect || false,
                      };
                    }),
                };
              })
              .filter(function (content) {
                return content.videos.length > 0;
              });

            // Prepare children data from treatment procedures
            const childrenData = (tp.treatment_procedures || []).map(function (procedure, index) {
              var discountValue = "%0";
              if (procedure.discount && procedure.discount !== "0.00" && procedure.discount !== "0") {
                discountValue = "%" + procedure.discount;
              }

              const code = procedure.procedure_code ? procedure.procedure_code.procedure_code : "-";
              const desc = procedure.procedure_code ? procedure.procedure_code.procedure_code_description : "-";
              const name = code !== "-" && desc !== "-" ? `${code} - ${desc}` : "-";

              return {
                key: `${tp.id}-${index}`,
                procedure_code: code,
                priority: null,
                name: name,
                tooth: procedure.tooth || "-",
                estimated_cost: procedure.estimated_cost || null,
                insurance_coverage: procedure.insurance_estimate || null,
                patient_responsibility: procedure.patient_responsibility || null,
                discount: discountValue,
                video_link: null,
                educational_content: [],
              };
            });

            return {
              key: tp.id,
              patient: item.patient,
              note: item.note,
              status: item.status,
              created_date: item.created_date,
              updated_date: item.updated_date,
              name: tp.name,
              tooth: tp.tooth_from,
              estimated_cost: tp.estimated_cost,
              priority: tp.priority,
              insurance_coverage: tp.insurance_coverage,
              discount: tp.discount ? `%${tp.discount}` : "%0",
              patient_responsibility: tp.patient_responsibility !== undefined && tp.patient_responsibility !== null ? tp.patient_responsibility : "-",
              video_link: tp.video_link,
              treatment_procedures: tp.treatment_procedures,
              payment_options_price: item.patient_responsibility > 0 ? Math.round((item.patient_responsibility / 72) * 1000) / 1000 : 0.0,
              educational_conent_count: tp.educational_content.length,
              educational_content: educationalContent,
              children: childrenData.length > 0 ? childrenData : undefined,
            };
          });
        })
        .sort((a, b) => {
          const aPriority = a.priority !== null && a.priority !== undefined ? a.priority : Infinity;
          const bPriority = b.priority !== null && b.priority !== undefined ? b.priority : Infinity;
          return aPriority - bPriority;
        });

      setData(flattenedData);

      // Check if there is any discount in the flattened data including children
      var discountExists = false;
      flattenedData.forEach(function (item) {
        if (item.discount !== "%0") {
          discountExists = true;
        }
        if (item.children) {
          item.children.forEach(function (child) {
            if (child.discount !== "%0") {
              discountExists = true;
            }
          });
        }
      });
      setHasDiscount(discountExists);
    }
  }, [props.data]);

  const rowClassName = (record, index) => {
    const classes = [];
    if (index === 0) {
      classes.push("hide-first-row");
    }
    if (record.procedure_code) {
      classes.push("child-row");
    }
    return classes.join(" ");
  };

  const columns = [
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      sorter: function (a, b) {
        const aPriority = a.priority !== null && a.priority !== undefined ? a.priority : Infinity;
        const bPriority = b.priority !== null && b.priority !== undefined ? b.priority : Infinity;
        return aPriority - bPriority;
      },
      defaultSortOrder: "ascend",
      width: hasDiscount ? "9%" : "10%",
      render: function (priority, record) {
        if (record.procedure_code) return null;
        return <Row align="bottom">{priority !== null && priority !== undefined ? priority : "-"}</Row>;
      },
    },
    {
      title: "Treatment",
      dataIndex: "name",
      key: "name",
      width: hasDiscount ? "13%" : "15%",
      render: function (name, record) {
        const isParent = !record.procedure_code;
        return (
          <Row align="bottom" style={{ fontWeight: isParent ? "bold" : "normal" }}>
            {isParent ? (
              name ? (
                name
              ) : (
                "-"
              )
            ) : (
              <Tooltip title={record.name} placement="top">
                <div
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    whiteSpace: "normal",
                    alignItems: "center",
                  }}
                >
                  {name}
                </div>
              </Tooltip>
            )}
          </Row>
        );
      },
    },
    {
      title: "Tooth / Quadrant",
      dataIndex: "tooth",
      key: "tooth",
      width: hasDiscount ? "9%" : "10%",
      render: function (tooth) {
        return <Row align="bottom">{tooth ? tooth : "-"}</Row>;
      },
    },
    {
      title: "Estimated Cost",
      dataIndex: "estimated_cost",
      key: "estimated_cost",
      width: hasDiscount ? "15.5%" : "17.5%",
      ellipsis: true,
      render: function (estimated_cost) {
        return (
          <Row align="bottom">{estimated_cost !== undefined && estimated_cost !== null ? `$${parseFloat(estimated_cost).toFixed(2)}` : "-"}</Row>
        );
      },
    },
    {
      title: "Insurance Coverage",
      dataIndex: "insurance_coverage",
      key: "insurance_coverage",
      width: hasDiscount ? "15.5%" : "17.5%",
      ellipsis: true,
      render: function (insurance_coverage) {
        return <Row align="bottom">{insurance_coverage !== null && insurance_coverage !== undefined ? `$${insurance_coverage}` : "-"}</Row>;
      },
    },
    {
      title: "Your Responsibility",
      dataIndex: "patient_responsibility",
      key: "patient_responsibility",
      width: hasDiscount ? "15.5%" : "17.5%",
      ellipsis: true,
      render: function (patient_responsibility) {
        return (
          <Row align="bottom">{patient_responsibility !== null && patient_responsibility !== undefined ? `$${patient_responsibility}` : "-"}</Row>
        );
      },
    },
    ...(hasDiscount
      ? [
          {
            title: "Discount",
            dataIndex: "discount",
            key: "discount",
            width: hasDiscount ? "14.5%" : "17.5%",
            ellipsis: true,
            render: function (discount) {
              return <Row align="bottom">{discount || "%0"}</Row>;
            },
          },
        ]
      : []),
    {
      title: "Patient Education",
      dataIndex: "video_link",
      key: "video_link",
      width: "15%",
      ellipsis: true,
      render: (video_link, record) => {
        if (record.procedure_code) return null;
        return (
          <TreatmentPlanTablePatientEducatoin
            isLoadingEducationalContent={isLoadingEducationalContent}
            setCurrentPage={setCurrentPage}
            handleEduList={handleEduList}
            currentPage={currentPage}
            edulist={edulist}
            record={record}
          />
        );
      },
    },
    {
      title: "Payment Options",
      dataIndex: "patient_responsibility",
      key: "patient_responsibility",
      width: hasDiscount ? "20.5%" : "22.5%",
      ellipsis: true,
      hidden: !props.data[0].optional,
      render: function (patient_responsibility, record) {
        if (record.procedure_code) return null;
        return (
          <Row align="bottom">
            <a rel="nofollow" href={props.financingProviderLink} target="_blank" referrerpolicy="no-referrer-when-downgrade">
              <Button type="primary" className="request-appointment-btn">
                As low as ${((patient_responsibility ? parseFloat(patient_responsibility) : 0) / 24).toFixed(2)}/mo
              </Button>
            </a>
          </Row>
        );
      },
    },
  ];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#983cfc",
          controlItemBgHover: "#c293ff",
          colorLink: "#983cfc",
        },
        components: {
          Table: {
            borderRadius: "8px",
            borderColor: "#eee",
          },
        },
      }}
    >
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        rowClassName={rowClassName}
        scroll={{ x: "max-content" }}
        rowKey="key"
        expandable={{
          rowExpandable: (record) => record.children && record.children.length > 0,
        }}
      />
    </ConfigProvider>
  );
};

export default TreatmentPlanTable;
